import {GetAttachment, GetAttachmentCallback} from "../types";

export class GetAttachmentDictionary implements GetAttachment {
    private items: { [key: string]: GetAttachmentCallback } = {};

    public containsKey(key: string): boolean {
        return this.items.hasOwnProperty(key);
    }

    public add(key: string, value: GetAttachmentCallback): void {
        this.items[key] = value;
    }

    public remove(key: string): void {
        delete this.items[key];
    }

    public get(key: string): GetAttachmentCallback {
        return this.items[key];
    }
}

export default new GetAttachmentDictionary();
